module.exports = __webpack_public_path__ + "static/media/megaphone.7aed20d8.svg";